import { generateUUID } from '../utils/uuid'

export default class Subscription {
	_eventId = null;
	_eventName = null;
	_eventHandler = null;
	_all = false;
	_listener = () => {};

	constructor(eventHandler, listener, eventName) {
		this._eventId = generateUUID();
		this._eventHandler = eventHandler;
		this._eventName = eventName;
		this._listener = listener;

		this._all = (arguments.length <= 2);
	}

	get eventId() {
		return this._eventId;
	}

	get eventName() {
		return this._eventName;
	}

	get listener() {
		return this._listener;
	}

	get all() {
		return this._all;
	}

	unsubscribe() {
		delete this._eventHandler.subscriptions[this._eventId];
	}
}
